import styled from "@emotion/styled";

import { Grid, darken, lighten } from "@mui/material";

import { BasicFlex } from '../../../utils/Common'

import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

const Header = styled.div`
  font-size: 1.6rem;
  font-weight: 600;
  color: ${props => props.theme.colors.mildText};
  margin-bottom: 2rem;
`

const MessageRules = styled.div`
  font-size: 1.6rem;
  background-color: ${props => props.theme.colors.darkBg};
  padding: 1.5rem;
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 12px;

  p {
    /* margin-bottom: 1rem; */
  }
`

const Tags = styled.ul`
  margin-top: 1.5rem;
  padding-left: 1.5rem;
  /* list-style: none; */
  /* font-size: 15px; */
  line-height: 1.6;
  color: ${props => props.theme.colors.mildText};
`;

const PriceRules = styled(BasicFlex)`
  font-size: 1.6rem;
  background-color: ${props => lighten(props.theme.colors.info, .9)};
  color: ${props => darken(props.theme.colors.info, .5)};
  padding: 1.5rem;
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 12px;
  margin-top: 1.5rem;
`

const MessageComponent = () => {

  return (
    <Grid size={{xs: 12}}>
      <Header>Deliver SMS Promotions</Header>
      <MessageRules>
        <p>
        This will send an SMS to <strong>all customers</strong> with a valid mobile number,
        or to a <strong>specific contact group</strong> if you select one below.
        Depending on the size of your list, delivery may take a few minutes to complete —
        you can track progress in real time once the blast is sent.
      </p>
        {/* <p style={{ marginTop: '8px' }}>
          Personalize your message using the placeholder below:
        </p> */}
        {/* <Tags>
          <li><b>{`{{first_name}}`}</b> will be replaced with the customer's first name</li>
          <li><b>{`{{full_name}}`}</b> will be replaced with the customer's full name</li>
        </Tags> */}
    </MessageRules>

    <PriceRules justify="flex-start" gap="1rem">
      <InfoRoundedIcon color="info" />
      <p>
        Pricing is based on SMS segments. Each segment is 150 characters. The price for each segment is $0.01.

      </p>
    </PriceRules>
    </Grid>
  )
};

export default MessageComponent;